import React, { useState } from 'react';
import styled from 'styled-components';

import { ChevronUp, ChevronDown } from '@/assets/icons';
import { flex, media } from '@/styles/theme';
import { SHIFTPICKUP_CART_HEADER_HEIGHT, Z_INDEX_AVAILABILITY_BASKET } from '@/config/variables';

interface ISlideUpCart {
  headerChildren: React.ReactNode;
  children: React.ReactNode;
}

const SlideUpCart = ({ headerChildren, children }: ISlideUpCart): React.ReactElement => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

  return (
    <Container>
      <ContainerHeader onClick={() => setIsCollapsed(!isCollapsed)}>
        {headerChildren}
        <img src={isCollapsed ? ChevronUp : ChevronDown} />
      </ContainerHeader>
      {!isCollapsed && children}
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: ${Z_INDEX_AVAILABILITY_BASKET};
  box-shadow: 1px 2px 5px 0px #4cbfbf;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;

  ${media.tablet} {
    right: 40px;
  }
  ${media.phone} {
    right: 5px;
    width: 285px;
  }

  width: 100%;
  max-height: 90vh;
`;

const ContainerHeader = styled.div.attrs({
  className: `ps-2 pe-3 ${flex.rowCenter} justify-content-between`,
})`
  height: ${SHIFTPICKUP_CART_HEADER_HEIGHT}px;
  background-color: #e6f3fc;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  cursor: pointer;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #0087dd;
  margin-left: 10px;
  flex-grow: 1;
`;

const RightText = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #0087dd;
  margin: 0 10px;
`;

SlideUpCart.Title = Title;
SlideUpCart.RightText = RightText;

export { SlideUpCart };
